/**
 * @generated SignedSource<<4d0a5b154cea51d03597678d3648581a>>
 * @relayHash b8396abaf95c66dd371cf8c447949e6e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 39f0bddaee9893a49ce3861c1b7e0c0f00ebe4820ecd06b736242cd414d01e45

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoardQuery } from './JiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "39f0bddaee9893a49ce3861c1b7e0c0f00ebe4820ecd06b736242cd414d01e45",
    "metadata": {},
    "name": "JiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
